<template>
  <div class="create_pt">
    <a-drawer :title="`${actType}推广链接`" :width="1200" :visible="showCreatePtForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form"  :model="model" :rules="rules" >

        <a-spin :spinning="loading" tip="Loading..." size="large">

        <a-form-model-item label="平台类型" prop="platform_type" help='目前只能选择常读和点众'>
          <a-select v-model="model.platform_type" @change="changePlatformType" disabled>
              <a-select-option :value="item.type" v-for="item in platformTypes" :key="item.type">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="平台" prop="platform_id" help='目前只能选择常读类型的平台'>
          <a-select v-model="model.platform_id" @change="changePlatform">
              <a-select-option :value="item.id" v-for="item in platforms" :key="item.id">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="model.platform_id" label="渠道" prop="distributor_id" >
          <a-select show-search option-filter-prop="children" v-model="model.distributor_id" @change="changeChannel">
              <a-select-option :value="item.id" v-for="item in channels" :key="item.id">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>



        <a-form-model-item label="推广链接名称" prop="name" help="1、名称会自动带上所选的广告主ID；2、推广链接名称只能输入汉字、字母、数字和中划线。">
          <a-input v-model="model.name"/>
        </a-form-model-item>

        <a-form-model-item label="固定面板模式" help="开启后，系统根据已选的账户基于主体来新建组，同一个主体的账户分配到一个组。然后自动选择充值模板，回传规则，单集价格">
          <a-switch checked-children="固定面板模式开" un-checked-children="固定面板模式关" v-model="fixedPanel"  :style="{ marginRight: '20px' }" @change="changeFixedPanel"/>
        </a-form-model-item>

        <a-form-model-item label="自动填充功能" help="开启后，新增组会自动填写第一个组当中的【短剧】和【起始付费集】的信息">
          <a-switch checked-children="自动填充开" un-checked-children="自动填充关" v-model="autoSelect"  :style="{ marginRight: '20px' }"/>
        </a-form-model-item>


        <div v-for="(row, index) in model.rows" :key="index" style="border:1px solid #cccccc;margin-top:40px;margin-bottom:40px;padding:10px">
         
          <a-row type="flex" style="margin-bottom:20px">
            <a-col flex="980px">
              <a-tag color="orange">
                组： {{ index+1 }}
              </a-tag>
            </a-col>
            <a-col flex="auto">
              <a href="#" @click="deleteRow(index)">删除</a>
            </a-col>
          </a-row>


          <a-form-model-item label="广告主" :prop="`rows[${index}].adv_ids`" help="本组广告主">
            <a-select show-search :autoClearSearchValue="false" allow-clear mode="multiple" option-filter-prop="children" v-model="row.adv_ids" option-label-prop="label" @change="changeAdvs(row)">
                <a-select-option :value="item.advertiser_id" v-for="item in model.selectAdvertisers" :key="item.advertiser_id" :label="item.advertiser_name">
                    {{ item.advertiser_name }} (备注：{{ item.remark }})
                </a-select-option>
            </a-select>
          </a-form-model-item>

         <!-- 一行多个 input -->
    <a-row :gutter="16" >
      <a-col :span="8" v-if="model.platform_id && ( model.distributor_id && model.pay_type!=2 || model.platform_id == 36 || model.platform_id == 174)">
        <a-form-model-item  label="充值模版" :prop="`rows[${index}].recharge_template_id`" help='实时数据'>
          <byted-select v-model="row.recharge_template_id" transfer filterable>
              <byted-option v-for="item in rechargeTemplates" :key="item.id" :value="item.id">
                {{ item.name }}
              </byted-option>
          </byted-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="8" v-if="model.platform_id">
        <a-form-model-item v-if="model.platform_id" label="短剧" :prop="`rows[${index}].video_id`" :help='model.platform_type == 9 ? "如果短剧列表没有，可以点击【新增短剧】添加；备注自动同步剧名和起始解锁剧集规则：xxx-剧名-解锁剧集 或者是：xxx-[剧名][解锁剧集], 最后一个-后面或者[]内的内容对应的是解锁剧集，倒数第二个-后面或者[]内的内容对应的是剧名":""'>
          <a-row type="flex">
            <a-col flex="auto">
              <byted-select v-model="row.video_id" transfer filterable @change="changeVideo(row)">
                  <byted-option v-for="item in videos" :key="item.out_id" :value="item.out_id">
                    {{ item.name }} - {{ item.out_id }} 
                  </byted-option>
              </byted-select>
            </a-col>
            <a-col flex="150px" >
              <a-button  @click="addVideo" >新增短剧</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-form-model-item label="推广集数" :prop="`rows[${index}].chapter_num`" help="第几章开始生成推广链">
          <a-select v-model="row.chapter_num">
              <a-select-option :value="chapter_num" v-for="chapter_num in chapterNums" :key="chapter_num">
                  第{{ chapter_num }}集
              </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-form-model-item label="起始付费集数" :prop="`rows[${index}].start_chapter`" help="剧集数不能低于5，不能高于93" v-if="model.pay_type!=2">
          <a-input-number style="width:100%" v-model="row.start_chapter" suffix="集" :min="5" :max="93" @change="changeStartChapter(row)"/>
        </a-form-model-item>
        <a-form-model-item label="起始解锁剧集" :prop="`rows[${index}].start_chapter`" help="剧集数不能低于2，不能高于最大集数" v-else>
          <a-input-number style="width:100%" v-model="row.start_chapter" suffix="集" :min="2" :max="89" @change="changeStartChapter(row)"/>
        </a-form-model-item>
      </a-col>
      <a-col :span="8" v-if="model.pay_type!=2 || model.platform_id == 36 || model.platform_id == 174">
        <a-form-model-item label="单集价格（元）" :prop="`rows[${index}].price`" help="填写范围：0.1-5 元" >
          <a-input-number style="width:100%"  v-model="row.price" suffix="元" :min="0.1" :max="5"/>
        </a-form-model-item>
      </a-col>
      <a-col :span="8" >
        <a-form-model-item v-if="model.platform_type == 9"  label="起量助手" :prop="`rows[${index}].pack_strategy_status`" help='仅推广链维度生效，开启后预估消耗+150%，ROI+4%'>
          <a-radio-group v-model="row.pack_strategy_status" >
            <a-radio-button :value="1">
              开启(推荐)
            </a-radio-button>
            <a-radio-button :value="0">
              关闭
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="设置关注章节" :prop="`rows[${index}].guide_chapter`" help="设置关注章节优先级:推广链接>短剧中心>平台兜底 (当前不可设置)" v-else>
          <a-input-number style="width:100%" v-model="row.guide_chapter" suffix="集" :min="0" disabled/>
        </a-form-model-item>

      </a-col>

      <a-col :span="8" v-if="customParams && customParams.length > 0">
        <a-form-model-item
          v-for="param in customParams"
          :key="param.param_id"
          :label="param.param_name"
          :prop="param.param_id"
          :required="param.show_config.is_required"
        >
          <a-select
            v-if="param.show_config.param_show_way === 1 && param.param_id == 'intelligentLanding'"
            :mode="param.show_config.is_multi ? 'multiple' : ''"
            :placeholder="`请选择${param.param_name}`"
            v-model="row[param.param_id]"
            :label-in-value="false"
            :option-filter-prop="'children'"
          >
          
            <a-select-option
              v-for="(item, index) in param.value_configs"
              :key="index"
              :value="item.value"              
            >
              {{ item.show_text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>

      <a-col :span="8" v-if="model.distributor_id">
        <a-form-model-item label="媒体渠道" :prop="`rows[${index}].media_source`" v-if="model.distributor_id">
          <a-select v-model="row.media_source" @change="changeMediaSource(index)">
              <a-select-option :value="item.id" v-for="item in mediaSources" :key="item.id">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="8" v-if="model.media_source && model.platform_id && model.distributor_id">
        <a-form-model-item label="回传规则" :prop="`rows[${index}].ad_callback_config_id`"  v-if="model.media_source" help="非实时数据，如对方平台新增，请联系运营同步数据">
          <a-row type="flex">
            <a-col :span="24">
              <byted-select v-model="row.ad_callback_config_id" transfer filterable>
                <byted-option :value="item.out_id" v-for="item in showConfigs[row.media_source]" :key="item.out_id">
                    {{ item.name }}
                </byted-option>
              </byted-select>
            </a-col>

            <a-col flex="150px">
              <a-button  @click="syncAdCallbackConfig()" v-if="accessTo('syncAdCallbackConfig')" icon="cloud-sync" >同步回传规则</a-button>
            </a-col>
          </a-row>
      
        </a-form-model-item>
        
        <!-- <a-form-model-item label="回传规则" :prop="`rows[${index}].ad_callback_config_id`"  v-if="model.media_source" help="非实时数据，如对方平台新增，请联系运营同步数据">
          <a-row type="flex">
            <a-col :span="24">
              <a-select v-model="row.ad_callback_config_id"  show-search option-filter-prop="children" >
                <a-select-option :value="item.out_id" v-for="item in showConfigs[row.media_source]" :key="item.out_id">
                    {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>

            <a-col flex="150px">
              <a-button  @click="syncAdCallbackConfig()" v-if="accessTo('syncAdCallbackConfig')" icon="cloud-sync" >同步回传规则</a-button>
            </a-col>
          </a-row>
      
        </a-form-model-item> -->
      </a-col>
    
    </a-row>

    </div>


           <!-- 新增按钮 -->
          <a-button type="primary" @click="addRow">新增推广组</a-button>

         

        <div class="result" v-if="result.success.length + result.errors.length > 0">
          <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
          <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
        </div>
 
      </a-spin>
      </a-form-model>

      <div v-if="showSubmit" :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">

        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading" :style="{ marginRight: '8px' }"> 仅创建推广链接 </a-button>
        <a-button type="primary" @click="next(1)" :disabled="loading" :style="{ background: 'orange', marginRight: '8px' }"> 提交并创建小程序(旧版) </a-button>
        <a-button type="primary" @click="next(2)" :disabled="loading" :style="{ background: 'red' }"> 提交并创建小程序(升级版) </a-button>
      </div>


      <a-modal :visible="showResult" :footer="null" @cancel="closerResult"  centered :title="`批量创建推广链接结果`" :width="'50%'">
          <div style="min-height:300px">
            <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
            <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
          </div>
      </a-modal>

      <a-modal
      title="新增短剧"
      centered
      :footer="null" 
      :width="640"
      :mask-closable="false"
      :visible="showCreateAddForm"
      :confirmLoading="loading"
      class="app-result"
      @cancel="closeAddVideo"
    >
          <a-form-model
            ref="form"
            :model="addvideoModel"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
          <div style="height:100px">
            <template v-if="model.platform_type === 4 && false">
              <a-form-model-item  label="短剧ID">
                <a-row type="flex">
                  <a-col flex="auto">
                    <a-input v-model="addvideoModel.video_id"/>
                  </a-col>
                  <a-col flex="150px"></a-col>
                </a-row>
              </a-form-model-item>

              <a-form-model-item  label="短剧名称" >
                <a-row type="flex">
                  <a-col flex="auto">
                    <a-input v-model="addvideoModel.video_name"/>
                  </a-col>
                  <a-col flex="150px">
                    <a-button type="primary"  @click="submitAddVideo" :disabled="loading" style="margin-left:60%">提交</a-button>
                  </a-col>
                </a-row>
              </a-form-model-item>

            </template>

            <template v-else>
              <a-form-model-item  label="短剧ID">
                <a-row type="flex">
                  <a-col flex="auto">
                    <!-- <a-input v-model="addvideoModel.video_id"/> -->
                     <a-textarea
                        v-model="addvideoModel.video_id"
                        :auto-size="{ minRows: 3, maxRows: 6 }"
                        placeholder="支持输入单个或多个短剧ID（多个时换行输入）"
                      />
                  </a-col>
                  <a-col flex="150px">
                    <a-button type="primary"  @click="submitAddVideo" :disabled="loading" style="margin-left:60%">提交</a-button>
                  </a-col>
                </a-row>
              </a-form-model-item>
            </template>
          </div>
            
           
          </a-form-model>
         
    </a-modal>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreatePt';
</style>

<script>
import CreatePt from './CreatePt'

export default CreatePt
</script>
